'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Widgets.ValidationSummary', []).controller('ValidationSummaryController', require('./controllers/ValidationSummaryController')).directive('rmValidationSummary', require('./directives/ValidationSummaryDirective'));